import Modal from "react-bootstrap/Modal";
import circularClose from "../asset/images/circular-close.svg"

function DeleteFlexInvoice(props) {
  const closeModal = () => {
    var datashow = props.show;
    props.setshow(!datashow);
  };
  // const navigate = useNavigate()

  return (
      <Modal
          show={props.show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="border-0 "
          onHide={() => props.setshow(false)}
      >
          <Modal.Body
              style={{
                  borderRadius: "16px",
                  padding: "0px",
                  border: "none",
              }}
          >
              <div className="flex items-start gap-4 px-4 py-4">
                  <div>
                      <img src={circularClose} alt="Close icon" />
                  </div>

                  <div>
                      <div className="flex items-center justify-between">
                          <h5 className="text-xl font-semibold text-gray-90">Delete invoice?</h5>

                          <span
                              className="cursor-pointer material-icons"
                              style={{ color: "#667085" }}
                              onClick={closeModal}
                          >
                              close
                          </span>
                      </div>
                      <p className="text-sm font-normal text-gray-70">
                          Deleting this will permanently remove all payment history for this
                          invoice. This can't be undone.
                      </p>
                  </div>
              </div>
              <div
                  className="flex items-center justify-end p-3 gap-x-5"
                  style={{
                      borderTop: "1px solid #E7E9FB",
                  }}
              >
                  <button
                      onClick={closeModal}
                      className="hover:opacity-90 mt-0 sm:!mt-0 flex items-center gap-2 text-gray-10 rounded-lg py-[10px] px-4 text-sm"
                  >
                      Cancel
                  </button>
                  <button
                      disabled={props.loader}
                      type="button"
                      onClick={props.deletedBuyer}
                      className="hover:opacity-90 !bg-danger-10 mt-0 sm:!mt-0 flex items-center gap-2 text-white rounded-lg py-[10px] px-4 text-sm"
                  >
                     {props.loader ? "Loading..." : "Delete invoice"}
                  </button>
              </div>
          </Modal.Body>
      </Modal>
  );
}

export default DeleteFlexInvoice;
